"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var MasterAreaItem = function (props) {
    var item = props.item, active = props.active, type = props.type, icon = props.icon, title = props.title, description = props.description, onItemSelected = props.onItemSelected, colorIcon = props.colorIcon, children = props.children;
    var className = active ? 'ant-app-masterarea-item active' : 'ant-app-masterarea-item';
    var handleClick = function () { return onItemSelected && onItemSelected(item); };
    var AvatarComponent = react_1.useMemo(function () { return (react_1.default.createElement(antd_1.Avatar, null,
        react_1.default.createElement(Icon_1.default, { name: icon || 'commons-document', color: colorIcon }))); }, [icon, colorIcon]);
    return (react_1.default.createElement("div", { className: className, onClick: handleClick },
        type === 'custom' && children,
        type === 'list' && (react_1.default.createElement(antd_1.List.Item, null,
            react_1.default.createElement(antd_1.List.Item.Meta, { avatar: AvatarComponent, title: title, description: description })))));
};
exports.default = MasterAreaItem;
